import { useEffect, useRef } from "react";

export default function ProgressRing({ percent = 0, size = 56, stroke = 6, color = "#726AF0", trackColor = "#E9E9E9", showLabel = true }) {
    const radius = (size - stroke) / 2;
    const circ = 2 * Math.PI * radius;
    const offset = circ - (percent / 100) * circ;
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) ref.current.style.strokeDashoffset = offset;
    }, [offset]);

    return (
        <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={radius} stroke={trackColor} strokeWidth={stroke} fill="none" />
                <circle
                    ref={ref}
                    cx={size / 2} cy={size / 2} r={radius}
                    stroke={color} strokeWidth={stroke} fill="none"
                    strokeDasharray={circ}
                    strokeDashoffset={circ}
                    strokeLinecap="round"
                    style={{ transition: "stroke-dashoffset 0.6s ease-out" }}
                />
            </svg>
            {showLabel && (
                <span className="absolute text-xs font-bold text-foreground" data-testid={`progress-${Math.round(percent)}`}>
                    {Math.round(percent)}%
                </span>
            )}
        </div>
    );
}
